import { BookerCalendarEvent } from '@chilipiper/api-type-def'
import { useEffect, useState } from 'react'
import { computeEventOfDay } from './helpers'
import { ComputeEventOfDayProps } from './types'

export const useComputeEventOfDay = ({ date, events }: ComputeEventOfDayProps) => {
  const [eventOfDay, setEventOfDay] = useState<BookerCalendarEvent[]>([])
  useEffect(() => {
    const computedEventOfDay = computeEventOfDay({ date, events })
    setEventOfDay(computedEventOfDay)
  }, [date, events])
  return eventOfDay
}
